import { render } from "./myMakeDesc.vue?vue&type=template&id=cd5cd8a4&scoped=true"
import script from "./myMakeDesc.vue?vue&type=script&lang=js"
export * from "./myMakeDesc.vue?vue&type=script&lang=js"

import "./myMakeDesc.vue?vue&type=style&index=0&id=cd5cd8a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd5cd8a4"]])

export default __exports__